import { render, staticRenderFns } from "./cakeType.vue?vue&type=template&id=ab965ba0&"
import script from "./cakeType.vue?vue&type=script&lang=js&"
export * from "./cakeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports